import { localeOptions } from "../../../../constants/templateMail";

export default {
  type: "template-mails",
  subject: Object.values(localeOptions).reduce(
    (acc, locale) => ({ ...acc, [locale]: null }),
    {}
  ),
  title: Object.values(localeOptions).reduce(
    (acc, locale) => ({ ...acc, [locale]: null }),
    {}
  ),
  from: { email: null, name: null },
  reply_to: { email: null, name: null },
  recipients: [],
  cc: [],
  bcc: [],
  logo: null,
  background_color: "#f5f6ec",
  sections: Object.values(localeOptions).reduce(
    (acc, locale) => ({ ...acc, [locale]: [""] }),
    {}
  ),
  title_style: {
    color: "#F5F6EC",
    bg_color: "#576654",
    font_family: '"Poppins", sans-serif',
    font_size: "14",
  },
  text_style: {
    color: "#02072c",
    bg_color: "#ffffff",
    font_family: '"Poppins", sans-serif',
    font_size: "14",
  },
  buttons_colors: {
    primary: "#FFFFFF",
    bg_primary: "#EF8152",
    secondary: "#6b7280",
    bg_secondary: "#f5f6ec",
  },
  links_style: {
    color: "#ef8152",
    font_family: '"Poppins", sans-serif',
    font_size: "14",
  },
  footer_style: {
    color: "#F5F6EC",
    bg_color: "#576654",
    font_family: '"Poppins", sans-serif',
    font_size: "14",
  },
  html_content: Object.values(localeOptions).reduce(
    (acc, locale) => ({ ...acc, [locale]: "" }),
    {}
  ),
  is_default: false,
  relationshipNames: ["organization", "typeMail"],
  organization: {
    type: "organizations",
    id: null,
  },
  typeMail: {
    type: "type-mails",
    id: null,
  },
};
